import ComponentImages from "~/components/ComponentImages/ComponentImages";
import ComponentStatusBar from "~/components/ComponentStatusBar/ComponentStatusBar";
import * as React from 'react';
export default {
  ComponentImages,
  ComponentStatusBar,
  React
};